<template>
    <FilterBuilderRow
        v-if="active"
        v-bind="rowProps()"
        @remove="remove"
    >
        <template #tooltip>
            <slot name="tooltip">{{ tooltipText }}</slot>
        </template>

        <!--
            O painel do calendário é anexado ao <body>. O FilterBuilder já ignora
            cliques em .el-picker-panel, então ele não fecha ao escolher uma data.
        -->
        <el-date-picker
            v-model="draft"
            class="fb-date-range"
            type="daterange"
            :disabled="disabled"
            size="small"
            unlink-panels
            :clearable="clearable"
            :start-placeholder="startPlaceholder"
            :end-placeholder="endPlaceholder"
            :format="format"
            :value-format="valueFormat"
            :picker-options="pickerOptions"
        />
    </FilterBuilderRow>
</template>

<script>
    import { DatePicker } from 'element-ui';
    import FilterBuilderRow from './FilterBuilderRow.vue';
    import filterBuilderItem from './filterBuilderItem';

    export default {
        name: 'FilterBuilderDateRange',
        mixins: [filterBuilderItem],
        props: {
            startPlaceholder: { type: String, default: 'Início' },
            endPlaceholder: { type: String, default: 'Fim' },
            format: { type: String, default: 'dd/MM/yyyy' },
            valueFormat: { type: String, default: 'yyyy-MM-dd' },
            clearable: { type: Boolean, default: true },
            // ex.: { shortcuts: [...] }
            pickerOptions: { type: Object, default: () => ({}) },
        },
        methods: {
            // v-model fica [inicio, fim] ou null
            getEmptyValue() {
                return null;
            },
        },
        components: {
            FilterBuilderRow,
            [DatePicker.name]: DatePicker,
        },
    };
</script>

<style scoped>
    .fb-date-range.el-date-editor {
        width: 100%;
    }
    .fb-date-range >>> .el-range-separator {
        padding: 0 2px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/_micro/FilterBuilder/FilterBuilderDateRange.vue